import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { theme } from "./Theme";
import { CopyToClipboard } from "react-copy-to-clipboard";
import cloudvideo from "../assets/cloudvideo.mp4";
import ReactPlayer from "react-player";
import { PortfolioContext } from "./AppContext";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

const Footer = () => {
	const [isTextCopied, setisTextCopied] = useState(false);
	const { setEnterFooter } = useContext(PortfolioContext);
	const handleDownload = () => {
		const link = document.createElement("a");
		link.href = "/Iqra Imran Syed.pdf";
		link.download = "Iqra Imran Syed.pdf";
		link.click();
	};

	const handleCopy = () => {
		setisTextCopied(true);
		setTimeout(() => {
			setisTextCopied(false);
		}, 5000);
	};

	useEffect(() => {
		const quotes = document.querySelectorAll(".wrap");
		const isMobile = window.innerWidth < 768;

		const setupSplits = () => {
			quotes.forEach((quote) => {
				if (quote.anim) {
					quote.anim.progress(1).kill();
					quote.split.revert();
				}
				if (!isMobile) {
					quote.split = SplitText.create(quote, {
						type: "words,chars",
						linesClass: "split-line",
					});
					quote.split.chars.forEach((char) => {
						char.style.display = "inline-block";
					});

					quote.anim = gsap.from(quote.split.chars, {
						scrollTrigger: {
							trigger: quote,
							toggleActions: "restart pause resume reverse",
							start: "center center",
						},
						duration: 0.6,
						ease: "circ.out",
						y: 80,
						stagger: 0.02,
					});
				}
			});
		};

		ScrollTrigger.addEventListener("refresh", setupSplits);
		setupSplits();
	}, []);

	return (
		<>
			<Div
				onMouseEnter={() => setEnterFooter(true)}
				onMouseLeave={() => setEnterFooter(false)}
			>
				<Container>
					<Text className="wrap">Let's work together</Text>
					<PlayerWrapper>
						<ReactPlayer
							url={cloudvideo}
							playing
							loop
							autoPlay
							muted
							playsinline
							controls={false}
							width="100%"
							height="auto"
							config={{
								file: {
									attributes: {
										playsInline: true,
										controls: false,
										muted: true,
										autoPlay: true,
									},
								},
							}}
						/>
					</PlayerWrapper>

					{isTextCopied && (
						<CopyConfirmation>
							<p>copied</p>
						</CopyConfirmation>
					)}
					<LinkContainer>
						<Links
							href="https://www.linkedin.com/in/iqraimransyed"
							target="_blank"
							rel="noopener noreferrer"
						>
							<h3>LINKEDIN</h3>
						</Links>
						<Links onClick={handleDownload}>
							<h3>RESUME</h3>
						</Links>
						<Links>
							<CopyToClipboard onCopy={handleCopy} text="syed@imraniqra.com">
								<h3>SYED@IMRANIQRA.COM</h3>
							</CopyToClipboard>
						</Links>
						<Links
							href="https://github.com/iqrasy"
							target="_blank"
							rel="noopener noreferrer"
						>
							<h3>GITHUB</h3>
						</Links>
					</LinkContainer>
				</Container>
			</Div>
			<FooterContainer>
				<p>Built and Designed by Iqra</p>
				<p>©2023 </p>
			</FooterContainer>
		</>
	);
};

export default Footer;

const Div = styled.div`
	background-color: var(--v1);
	color: var(--v2);
	min-height: 100vh;
	width: 100vw;
	padding: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
	will-change: transform;
	box-sizing: border-box;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: auto;
	min-height: 30rem;
	width: 100%;
	margin: 0 auto;
	gap: 16px;

	.icon {
		border: solid green 1px;
		display: inline-block;
		animation: spin 6s linear infinite;
		@keyframes spin {
			from {
				transform: rotate(0deg);
			}
			to {
				transform: rotate(360deg);
			}
		}

		@media (max-width: ${theme.breakpoints.sm}) {
			font-size: 35px;
		}
	}
`;

const Text = styled.p`
	margin: 0;
	color: var(--v2);
	font-size: clamp(36px, 8vw, 80px);
	line-height: 0.9;
	font-family: "Darline Script";

	@media (max-width: ${theme.breakpoints.sm}) {
		letter-spacing: -2px;
	}
`;

const CopyConfirmation = styled.div`
	position: relative;
	top: 0;
	height: 40px;
	width: 80px;
	background-color: var(--v2);
	border-radius: 5px;
	padding: 7px 10px;
	color: var(--v1);
	white-space: nowrap;
	animation: myAnim 0.4s ease 0s 1 normal forwards;

	p {
		text-align: center;
		font-size: clamp(10px, 2vw, 15px);
		margin: 0 auto;
	}

	@keyframes myAnim {
		0% {
			transform: translateY(0);
		}
		100% {
			transform: translateY(-40px);
		}
	}
`;

const LinkContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	gap: clamp(0.75rem, 2vw, 2rem);
	width: 100%;
	padding: 0 10px;
	box-sizing: border-box;
`;

const Links = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-family: "Poppins", sans-serif;
	font-weight: bolder;
	text-align: center;
	transition: all 0.6s ease;
	cursor: pointer;

	&:hover {
		border-radius: 7px;
		padding: 5px;
		color: var(--v2);
		background-color: var(--v4);
		transition: all 0.3s ease-in-out;
	}

	h3 {
		font-size: clamp(14px, 1.2vw, 15px);
		white-space: nowrap;
	}
`;

const PlayerWrapper = styled.div`
	width: 50%;
	display: flex;
	justify-content: center;
	align-items: center;

	> div {
		width: 100% !important;
	}

	@media (max-width: ${theme.breakpoints.md}) {
		width: 70%;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		width: 100%;
	}
`;

const FooterContainer = styled.footer`
	display: flex;
	justify-content: space-between;
	font-size: clamp(8px, 1.2vw, 12px);
	background-color: var(--v1);
	color: var(--v2);
	padding: 10px;
`;
